import React from 'react';
import MUIButton from '@mui/material/Button';
import { SxProps, Theme } from '@mui/material';

interface ButtonProps {
    addStyle?: string;
    children: React.ReactNode;
    onClick?: () => void;
    style?: React.CSSProperties; 
    sx?: SxProps<Theme>;
    onMouseEnter?: () => void; 
    onMouseLeave?: () => void; 
    disabled?: boolean;
    hidden?: boolean;
    title? : string;
}

const Button: React.FC<ButtonProps> = ({ addStyle, children, onClick, style, sx, disabled, hidden, title, ...otherProps }) => {
    return (
        <MUIButton className={addStyle} onClick={onClick} {...otherProps} style={style} sx={sx} disabled={disabled} hidden={hidden} title={title}>
            {children}
        </MUIButton>
    );
}

export default Button;
